// extracted by mini-css-extract-plugin
module.exports = {"languageButton":"Header_languageButton__rpPZX","languageDivider":"Header_languageDivider__F5s5_","skiplink":"Header_skiplink__5BKgb","language":"Header_language__KEu1A"};